import React from 'react';

import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { defineMessage, useIntl } from 'react-intl';

import type {
	CommonDraggableSideNavItemProps,
	DefaultItemType,
} from '@townsquare/griffin-navigation/types';

const openInNewTabLabel = defineMessage({
	id: 'townsquare.goals-app.side-nav.open-in-new-tab',
	description:
		'Label on an external link icon for links to 0]00][0products in the side nav which will open the link in a new tab',
	defaultMessage: 'Open in new tab',
});

// Side nav item with external link icon
export const ExternalSideNavItem = (
	props: CommonDraggableSideNavItemProps & { item: DefaultItemType },
): React.JSX.Element => {
	const { isSelected, onClick, item } = props;
	const intl = useIntl();

	return (
		<LinkMenuItem
			onClick={(e) => onClick(item, e)}
			isSelected={isSelected}
			href={item.path}
			elemBefore={<item.Icon label="" />}
			elemAfter={
				<LinkExternalIcon
					label={intl.formatMessage(openInNewTabLabel)}
					color="currentColor"
					spacing="spacious"
					size="small"
				/>
			}
			testId={item.testId}
			hasDragIndicator={props.hasDragIndicator}
			ref={props.draggableRef}
			isDragging={props.isDragging}
			dropIndicator={props.dropIndicator}
			visualContentRef={props.visualContentRef}
		>
			{item.name}
		</LinkMenuItem>
	);
};
